import type { SVGProps } from "react";
export interface CallOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CallOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CallOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.683.978a3.194 3.194 0 0 1 3.66 1.662l1.094 2.189c.577 1.152.4 2.53-.424 3.498l-.175.187-1.013 1.012q.035.084.073.169a1.125 1.125 0 1 1-2.044.942 10 10 0 0 1-.408-1.032c-.135-.404-.03-.85.27-1.15l1.531-1.532a.94.94 0 0 0 .178-1.088L7.33 3.646a.94.94 0 0 0-.994-.508l-.172.044-2.45.89c-.417.152-.636.547-.58.91l.089.547c.442 2.524 1.231 4.759 2.33 6.688l.24.409.056.101a1.126 1.126 0 0 1-1.914 1.16l-.065-.095-.272-.461c-1.24-2.178-2.11-4.663-2.591-7.414L.91 5.324c-.229-1.499.681-2.873 2.035-3.365l2.45-.892.288-.09Zm15.521.227a1.125 1.125 0 0 1 1.59 1.59l-10.81 10.811a10.5 10.5 0 0 0 2.49 1.566l1.012-1.01a3.19 3.19 0 0 1 3.686-.599l2.188 1.095a3.193 3.193 0 0 1 1.573 3.946l-.892 2.45c-.492 1.354-1.865 2.266-3.363 2.037-4.474-.684-8.261-2.37-11.205-4.976l-4.678 4.66a1.125 1.125 0 0 1-1.588-1.594l5.448-5.426 14.55-14.55ZM9.068 16.52c2.563 2.23 5.896 3.725 9.949 4.345l.138.009a.86.86 0 0 0 .771-.588l.891-2.452a.943.943 0 0 0-.464-1.166l-2.189-1.093a.94.94 0 0 0-.974.08l-.114.096-1.53 1.53a1.13 1.13 0 0 1-1.152.273c-1.417-.472-2.794-1.316-4.005-2.355z"
      />
    </svg>
  );
}
